import { Component, OnInit } from '@angular/core';

export interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
  childMenu:Array<object>;
}

export const ROUTES: RouteInfo[] = [
  {
      path: '/user-home', title: 'Accueil', icon:'nc-bank', class: '',
      childMenu: null
  },

  { path: '/ask-question', title: 'Démander une question', icon:'nc-support-17', class: '',
      childMenu: null
  },
  ,

  { path: '/my-questions', title: 'Mes questions répondues', icon:'nc-support-17', class: '',
      childMenu: null
  }
];

@Component({
  selector: 'app-user-side-bar',
  templateUrl: './user-side-bar.component.html',
  styleUrls: ['./user-side-bar.component.scss']
})
export class UserSideBarComponent implements OnInit {
  public menuItems: any[];
  ngOnInit() {
      this.menuItems = ROUTES.filter(menuItem => menuItem);
  }
}
